<template lang="pug">
  v-layout.pa-0(row fill-height)
    v-flex(xs12 grow)
      v-data-table(
        :headers="tableHeaders"
        :items="tableItems"
        :options.sync="tableOptions"
        :hide-default-header="true"
      )
        template(v-slot:header="{ props: { headers } }")
          thead
            tr
              th.status
              th(v-for="header in headers" :key="header.value" :class="{ 'active': header.value === selected }") {{ header.text }}

        template(v-slot:body="{ items, pagination, headers }")
          tr(v-for="(item, idx) in items" :key="idx")
            td.status
              v-icon(:color="_status(item).color") {{ _status(item).icon }}
            td(v-for="header in headers" :key="header.value" :class="{ 'active': header.value === selected }") {{ item[header.value] }}

        template(v-slot:no-data)
          p Data not avalible
</template>

<script>
const STATUS_ICONS = {
  WAIT: { icon: 'info', color: '#dddddd' },
  SUCCESS: { icon: 'check_circle', color: 'green' },
  CANCELLED: { icon: 'cancel', color: 'orange' },
  NOTFOUND: { icon: 'info', color: 'red' },
  ERROR: { icon: 'info', color: 'red' }
}

export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [String, Number],
      default: () => -1
    }
  },
  data () {
    return {
      tableHeight: '',
      tableOptions: {
        rowsPerPage: 10
      }
    }
  },
  mounted () {
    const h = (this.$el || {}).clientHeight
    if (!h) {
      return setTimeout(this.mounted, 1000)
    }
    this.tableHeight = h - 60 // 60 is foooter pagination
  },
  computed: {
    tableItems () {
      return this.items || null
    },
    tableHeaders () {
      return this.headers || null
    }
  },
  methods: {
    _status (item) {
      const status = item.$status || null
      return STATUS_ICONS[status] || STATUS_ICONS.WAIT
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-data-table
  >>> th.active, >>> td.active
    color: black
    background: rgba(red, 0.1)

  >>> td.updated
    background: rgba(green 0.1)
</style>
